module.exports = __webpack_public_path__ + "static/media/vvd-logo-02b-1x.1f4c8133.webp";